import { Inject, Injectable } from '@angular/core';
import { DialogService } from '../dialog/dialog.service';
import { TrialEndedDialogComponent } from './trial-ended-dialog.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TrialEndedDialogService {
  readonly MODAL_WIDTH = 478;
  MODAL_ID = 'mode-trial-expired-dialog-modal';

  constructor(
    private dialogService: DialogService,
    private overlayContainer: OverlayContainer,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: TS7060
  open(userDisplayName?: string, userEmail?: string, disableClose = false) {
    // check to see if the dialog modal already exists
    const dialogExist = this.dialogService.getDialogById(this.MODAL_ID);

    if (this.onlyDialogReferencePresent(dialogExist)) {
      dialogExist?.close();
      if (this.MODAL_ID == 'mode-trial-expired-dialog-modal-new') {
        this.MODAL_ID = 'mode-trial-expired-dialog-modal';
      } else {
        this.MODAL_ID = 'mode-trial-expired-dialog-modal-new';
      }
    }

    // open it, if it doesn't exist
    if (!dialogExist || !this.dialogPresentOnTheView()) {
      this.createOverlayContainer();
      return this.dialogService
        .open({
          component: TrialEndedDialogComponent,
          matDialogConfig: {
            width: `${this.MODAL_WIDTH}px`,
            id: this.MODAL_ID,
            data: {
              userDisplayName,
              userEmail,
            },
            disableClose,
          },
        })
        .afterClosed();
    }
  }

  dialogPresentOnTheView() {
    let expiryDialog = this._document.getElementById(this.MODAL_ID);
    return expiryDialog !== null && expiryDialog !== undefined;
  }

  onlyDialogReferencePresent(dialogRef: MatLegacyDialogRef<TrialEndedDialogComponent> | undefined) {
    return dialogRef && !this.dialogPresentOnTheView();
  }

  overlayContainerMissing() {
    let overlayElement = this._document?.querySelector('.cdk-overlay-container');
    return overlayElement !== undefined || overlayElement !== null;
  }

  createOverlayContainer() {
    if (this.overlayContainerMissing()) {
      const containerElement = this.overlayContainer.getContainerElement();
      const bodyElement = this._document.querySelector('body');
      bodyElement?.appendChild(containerElement);
    }
  }
}
